// TODO: refactor into ui-kit component (https://app.clickup.com/t/86c1e0q86)

import { themeStyle as uiKitThemeStyle } from '@repo/ui-kit/themeStyle';
import styled from 'styled-components';

const baseStyles = ({ isActive }: { isActive?: boolean }) => `
  // component tokens
  --menu-button-padding: var(--spacing-8);

  --menu-button-bg-hover: var(--color-bg-fill-hover);
  --menu-button-bg-active: var(--color-bg-fill-active);

  --menu-button-label-color: var(--color-text-secondary);
  --menu-button-label-color-hover: var(--color-text);
  --menu-button-label-color-active: var(--color-text);

  --menu-button-radius: var(--border-radius-7);

  // resets
  margin: 0;
  border: 0;
  background: none;

  display: flex;
  align-items: center;
  padding: var(--menu-button-padding);
  gap: var(--spacing-8);
  background-color: ${isActive ? 'var(--menu-button-bg-active)' : 'transparent'};
  width: 100%;
  border-radius: var(--menu-button-radius);
  cursor: pointer;

  // the chevron should not change color on hover, only the main icon
  & > .ui-icon-main-wrapper {
    --icon-color:${
      isActive
        ? 'var(--menu-button-label-color-active)'
        : 'var(--menu-button-label-color)'
    } !important;
  }

  // it changes the color of the label
  & > span {
    color: ${
      isActive
        ? 'var(--menu-button-label-color-active)'
        : 'var(--menu-button-label-color)'
    };
  }

  &:hover {
    background: var(--menu-button-bg-hover);

    // the chevron should not change color on hover, only the main icon
    & > .ui-icon-main-wrapper {
      --icon-color: var(--menu-button-label-color-hover) !important;
    }

    & > span {
      color: var(--menu-button-label-color-hover);
    }
  }

  transition:
    background ${uiKitThemeStyle.motionDuration300} ease-in-out;

  & > .ui-icon-main-wrapper {
    transition: fill ${uiKitThemeStyle.motionDuration300} ease-in-out;
  }

  & > span {
    transition: color ${uiKitThemeStyle.motionDuration300} ease-in-out;
  }

`;

export const StyledButton = styled.button<{
  isActive?: boolean;
  ['data-disable-nprogress']?: boolean;
}>`
  ${baseStyles}
`;

export const StyledAnchor = styled.a<{
  isActive?: boolean;
  ['data-disable-nprogress']?: boolean;
}>`
  ${baseStyles}
`;
